(function () {
    var sidebarAccess = {
        elements: {
            sidebarAccessEl: null,
            dismissBtn: null
        },
        selectors: {
            sidebarAccess: '.sidebar-region--access',
            dismissBtn: '.sidebar-region--access__close'
        },
        init: () => {
            sidebarAccess.elements.sidebarAccessEl = document.querySelector(sidebarAccess.selectors.sidebarAccess);
            if (sidebarAccess.elements.sidebarAccessEl) {
                sidebarAccess.elements.dismissBtn = document.querySelector(sidebarAccess.selectors.dismissBtn);
            }
            sidebarAccess.control();
        },
        control: () => {
            sidebarAccess.elements.dismissBtn?.addEventListener('click', sidebarAccess.dismissAccess);
        },
        dismissAccess: () => {
            sidebarAccess.elements.sidebarAccessEl.classList.add('dismissed');
        },
    };

    UX.sidebarAccess = sidebarAccess; // add to global namespace
})();
